import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { LEGAL_DOCS, LEGAL_TITLES } from '../legal/legalContent';
import { getInitialLang } from '../legal/lang';

// Compact footer with links to all legal documents. Used on the landing
// and activation screens, which otherwise have no app chrome.
export default function LegalFooter({ style, color = '#B9A68E', fontFamily = 'Poppins' }) {
  const [lang] = useState(getInitialLang);

  return (
    <footer
      style={{
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '6px 14px',
        padding: '20px 16px',
        ...style,
      }}
    >
      {LEGAL_DOCS.map((d) => (
        <Link
          key={d}
          to={`/legal/${d}`}
          style={{ fontFamily, fontSize: 12, color, textDecoration: 'none' }}
        >
          {LEGAL_TITLES[lang][d]}
        </Link>
      ))}
    </footer>
  );
}
